import { nextTick, watch } from 'vue';
import { envToBoolean } from '@/helpers/utils';
import useAuthService from './apiServices/useAuthService';
import { useI18n } from 'vue-i18n';
import { ROUTE_NAMES } from '@/router/conf';
import { useRouter } from 'vuetify/lib/composables/router.mjs';

const useAuthPasswordRedirect = () => {
  const { me } = useAuthService();
  const { data: meData } = me();
  const { locale } = useI18n();
  const router = useRouter();

  watch([() => meData.value?.isPwned, () => meData.value?.requirePasswordChange], async (newMe) => {
    if (!envToBoolean(import.meta.env.VITE_FORCE_PASSWORD_CHANGE_ENABLED)) return;
    const [isPwned, requirePasswordChange] = newMe;
    if (isPwned || requirePasswordChange) {
      console.info('User requires password change, redirecting to password change page');

      if (import.meta.env.VITE_AUTH_BASE_URL && meData.value?.email) {
        const url = new URL('/', import.meta.env.VITE_AUTH_BASE_URL);
        url.searchParams.append('lang', locale.value);
        url.searchParams.append('forceChange', meData.value.email);
        url.searchParams.append('reason', isPwned ? 'pwned' : 'admin');
        window.location.href = url.toString();
      } else {
        await nextTick();
        await router?.push({
          name: ROUTE_NAMES.SECURITY_ACCOUNT_PASSWORD
        });
      }
    }
  });
};

export default useAuthPasswordRedirect;
